// CDTM Run Club — Shopify Theme JS

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function() {
  var toggle = document.querySelector('.nav-mobile-toggle');
  var menu   = document.getElementById('mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', function() {
      menu.classList.toggle('open');
    });
  }

  // Product page: thumbnail gallery switcher
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImg = document.getElementById('main-product-img');
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.getAttribute('data-src');
        mainImg.alt = thumb.getAttribute('data-alt') || '';
      }
    });
  });

  // Quantity buttons
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus  = document.querySelector('.qty-plus');
  var qtyInput = document.querySelector('.qty-input');
  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value) || 1;
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', function() {
      var v = parseInt(qtyInput.value) || 1;
      qtyInput.value = v + 1;
    });
  }

  // Variant picker
  var variantBtns = document.querySelectorAll('.variant-btn');
  var variantInput = document.getElementById('variant-id');
  variantBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.classList.contains('unavailable')) return;
      // Deselect siblings in same group
      var group = btn.closest('.variant-options');
      group.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      // Update hidden variant input
      if (variantInput && btn.getAttribute('data-variant-id')) {
        variantInput.value = btn.getAttribute('data-variant-id');
      }
    });
  });

  // Fade up on scroll
  var fadeEls = document.querySelectorAll('.fade-up-scroll');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(function(el) { observer.observe(el); });
  }
});
